var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DefaultAccountHistoryApis, DefaultSteemEngineRpcs, } from '@interfaces/steem-engine-rpc.interface';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
let rpc = 'https://api.steem-engine.com/rpc';
let accountHistoryApi = 'https://history.steem-engine.com';
const getApi = () => {
    return rpc;
};
const setActiveApi = (api) => {
    rpc = api;
};
const getAccountHistoryApi = () => {
    return accountHistoryApi;
};
const setActiveAccountHistoryApi = (api) => {
    accountHistoryApi = api;
};
const addCustomRpc = (api) => __awaiter(void 0, void 0, void 0, function* () {
    const savedCustomRpcs = yield SteemEngineConfigUtils.getCustomRpcs();
    savedCustomRpcs.push(api);
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_CUSTOM_RPC_LIST, savedCustomRpcs);
});
const deleteCustomRpc = (api) => __awaiter(void 0, void 0, void 0, function* () {
    let customRpcs = (yield getCustomRpcs()).filter((rpc) => rpc !== api);
    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_CUSTOM_RPC_LIST, customRpcs);
    return customRpcs;
});
const getCustomRpcs = () => __awaiter(void 0, void 0, void 0, function* () {
    const customRpcs = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_CUSTOM_RPC_LIST);
    return customRpcs ? customRpcs : [];
});
const getCustomAccountHistoryApi = () => __awaiter(void 0, void 0, void 0, function* () {
    const customAccountHistoryApis = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_CUSTOM_ACCOUNT_HISTORY_API);
    return customAccountHistoryApis ? customAccountHistoryApis : [];
});
const addCustomAccountHistoryApi = (api) => __awaiter(void 0, void 0, void 0, function* () {
    const savedCustomAccountHistoryApis = yield SteemEngineConfigUtils.getCustomAccountHistoryApi();
    savedCustomAccountHistoryApis.push(api);
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_CUSTOM_ACCOUNT_HISTORY_API, savedCustomAccountHistoryApis);
});
const deleteCustomAccountHistoryApi = (api) => __awaiter(void 0, void 0, void 0, function* () {
    let customHistoryAccountsApi = (yield getCustomAccountHistoryApi()).filter((rpc) => rpc !== api);
    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_CUSTOM_ACCOUNT_HISTORY_API, customHistoryAccountsApi);
    return customHistoryAccountsApi;
});
const isRpcDefault = (rpc) => {
    return DefaultSteemEngineRpcs.includes(rpc);
};
const isAccountHistoryApiDefault = (api) => {
    return DefaultAccountHistoryApis.includes(api);
};
const saveConfigInStorage = (config) => __awaiter(void 0, void 0, void 0, function* () {
    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_ACTIVE_CONFIG, config);
});
export const SteemEngineConfigUtils = {
    getApi,
    setActiveAccountHistoryApi,
    setActiveApi,
    getAccountHistoryApi,
    addCustomRpc,
    addCustomAccountHistoryApi,
    deleteCustomRpc,
    deleteCustomAccountHistoryApi,
    getCustomRpcs,
    getCustomAccountHistoryApi,
    isRpcDefault,
    isAccountHistoryApiDefault,
    saveConfigInStorage,
};
